import { CoreWebsiteCell } from "pro-features/components/core cells/src/CoreWebsiteCell/CoreWebsiteCell";
import styled from "styled-components";
import type { FC } from "react";
import { allTrackers } from "app/services/track/track";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { QualificationSideBarCellButton } from "app/components/React/Table/cells/QualificationSideBarCellButton";

const CompanyCellContainer = styled(FlexRow)`
    width: 100%;
`;

interface ITrackingObject {
    category: Parameters<typeof allTrackers.dispatchTrackEvent>[0];
    action: Parameters<typeof allTrackers.dispatchTrackEvent>[1];
    name: Parameters<typeof allTrackers.dispatchTrackEvent>[2];
    customAttributes?: Parameters<typeof allTrackers.dispatchTrackEvent>[3];
}

interface IDomainCellWithTagProps {
    value: string;
    row: any;
    dataAutomationAttribute: string;
    tag: string;
    textAndIconMargin?: string;
    trackingObject?: ITrackingObject;
    showToolTip?: boolean;
    handleOpenQualificationSideBar?: (row: any) => void;
    onChipClick?: (tag: string) => void;
    tagTooltip?: string;
    isTagDisabled?: boolean;
}

export const DomainCellWithTag: FC<IDomainCellWithTagProps> = ({
    value,
    row,
    dataAutomationAttribute,
    tag,
    trackingObject,
    showToolTip = true,
    textAndIconMargin,
    handleOpenQualificationSideBar,
    onChipClick,
    tagTooltip,
    isTagDisabled,
}) => {
    return (
        <CompanyCellContainer data-automation={dataAutomationAttribute}>
            <CoreWebsiteCell
                withWebsiteSign={false}
                icon={row.favicon}
                domain={value}
                textAndIconMargin={textAndIconMargin}
                trackExternalLink={() =>
                    trackingObject &&
                    allTrackers.dispatchTrackEvent(
                        trackingObject.category,
                        trackingObject.action,
                        trackingObject.name,
                        trackingObject.customAttributes,
                    )
                }
                hideTrackButton={true}
                showToolTip={showToolTip}
                internalLink={row.internalLink}
                handleOpenQualificationSideBar={row.handleOpenQualificationSideBar}
                tag={tag}
                spacingDomainAndAddons={false}
                onChipClick={onChipClick}
                showChipActionButton={onChipClick !== undefined}
                chipTooltip={tagTooltip}
                isTagDisabled={isTagDisabled}
            />
            {handleOpenQualificationSideBar ? (
                <QualificationSideBarCellButton
                    domain={value}
                    favicon={row.favicon}
                    handleOpenQualificationSideBar={handleOpenQualificationSideBar}
                />
            ) : null}
        </CompanyCellContainer>
    );
};
